module.exports = __webpack_public_path__ + "img/logo2.71c40fea.png";